<div class="income-statement-eps">
  <klt-section title="Earnings per Share (EPS)" type="none">
    <div class="graph-box">
      <klt-graph
        [loading]="clientQuery.selectFinancialIsLoading$ | async"
        (filter)="runFilter($event)"
        [options]="options"
        [titles]="titles"
        [height]="height"
      ></klt-graph>
    </div>
  </klt-section>
</div>
